// Illustrations: a sheet to draw on.
//
// The second part of the meeting is, for most advisors, drawn by hand: the tax
// triangle and whatever follows from it, "as if they are just coming up with
// this right now" (Amanda Cook, 2026-10-02). They used to close the document
// and open a whiteboard to do it. So after the goal sheet the meeting has
// whiteboards of its own, as many as the advisor starts, each a plain sheet
// with no title and nothing on it (Jimmy, 2026-10-03). The marker is already
// in hand when one opens, and every one that is drawn on prints at the back
// of the takeaway.
//
// The page is the same fixed sheet as every other, which is what lets a
// drawing made on an iPad appear in the same place on the screen beside it
// and on paper afterwards.

export default function Whiteboard() {
  return <div className="conv-whiteboard" aria-hidden="true" />;
}
